const loadFavorites = () => (
  new Set(JSON.parse(localStorage.getItem('productFavorites')) || [])
);

const saveFavorites = (favorites) => {
  localStorage.setItem(
    'productFavorites',
    JSON.stringify([...favorites]),
  );
};

export {
  loadFavorites,
  saveFavorites,
};
